import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=6a4470ec&scoped=true"
import script from "./MessageAttachment.vue?vue&type=script&lang=js"
export * from "./MessageAttachment.vue?vue&type=script&lang=js"
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=6a4470ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4470ec",
  null
  
)

export default component.exports